import axios from 'axios';
import {
    REQUEST_RER_EMPLOYEE_ENDPOINT,
    REQUEST_RER_ENDPOINT,
    REQUEST_RER_PUBLIC_EMPLOYEE_ENDPOINT, REQUEST_RER_PUBLIC_ENDPOINT,
} from "@/constants/endpoints";
import authHeader from "@/services/auth-header";
import CreateRERPayload, {CreateREREmployeePayload} from "@/dto/request/rer/CreateRERPayload";
import {PublicREREmployeeDTO} from "@/dto/request/rer/PublicREREmployeeDTO";
import CompleteREREmployeePayload from "@/dto/request/rer/CompleteREREmployeePayload";
import {RER_DTO} from "@/dto/request/rer/RER_DTO";
import Short_RER_DTO from "@/dto/request/rer/Short_RER_DTO";

class RERService {

    create(payload: CreateRERPayload) {
        return axios.post(REQUEST_RER_ENDPOINT, payload, {headers: authHeader()});
    }

    getEmployeeByPublicId(id: string) {
        return axios.get<PublicREREmployeeDTO>(`${REQUEST_RER_PUBLIC_EMPLOYEE_ENDPOINT}/${id}`);
    }

    saveEmployeeByPublicId(id: string, payload: PublicREREmployeeDTO) {
        return axios.put(`${REQUEST_RER_PUBLIC_EMPLOYEE_ENDPOINT}/${id}`, payload);
    }

    getById(id: number) {
        return axios.get<Short_RER_DTO>(`${REQUEST_RER_ENDPOINT}/${id}`, {headers: authHeader()});
    }

    completeFillingEmployees(id: string) {
        return axios.put(`${REQUEST_RER_PUBLIC_ENDPOINT}/${id}/status/filled`);
    }

    completeEmployeeRegistration(payload: CompleteREREmployeePayload) {
        return axios.put(REQUEST_RER_EMPLOYEE_ENDPOINT, payload, {headers: authHeader()});
    }

    addEmployee(payload: CreateREREmployeePayload, id: string) {
        return axios.post(`${REQUEST_RER_ENDPOINT}/p/${id}/employee`, payload, {headers: authHeader()});
    }

    getByPublicId(id: string) {
        return axios.get<RER_DTO>(`${REQUEST_RER_ENDPOINT}/p/${id}`, {headers:authHeader()})
    }

    sendI9ForSigning(id: number) {
        return axios.put(`${REQUEST_RER_EMPLOYEE_ENDPOINT}/${id}/sign/i9`, '', {headers: authHeader()});
    }

    getFullInformationEmployee(id: number) {
        return axios.get<PublicREREmployeeDTO>(`${REQUEST_RER_EMPLOYEE_ENDPOINT}/${id}`, {headers: authHeader()});
    }

    skipUploadingStage(id: number) {
        return axios.put(`${REQUEST_RER_EMPLOYEE_ENDPOINT}/${id}/skip`, null, {headers: authHeader()});
    }

}

export default new RERService();
